window.getCookieByName = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        // Cannot use String.prototype.startsWith due to old browser support
        const regex = new RegExp(`^${name}=`, 'i');
        if (regex.test(cookie)) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
}
